export const manifestLocales = {
  summaryPageTaskSubmittedNotification: {
    previewImageAlt: {
      en: 'Summary Page Task Submitted Notification',
      he: 'תמונת מצב: סטטוס שאלות פתוחות'
    }
  }
};
